import { connect } from 'react-redux';

import { fetchMoEvents } from 'api/mo/mo.actions';
import { MoEventsList } from './MoEventsList';

const mapDispatchToProps = (dispatch: Function) => ({
  fetch: () => dispatch(fetchMoEvents()),
});

export const MoEventsListContainer = connect(null, mapDispatchToProps)(MoEventsList);
